export default __webpack_public_path__ + "static/media/acceso-camara-mac-3.1c4cd946.svg";